import React from 'react';
import { any, compose, path, props } from 'ramda';

import { currency, schedule, workplace, worktype } from 'constants/dictionaries';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import LoadField from 'components/common/fields/LoadField';
import RequestSalary from './RequestSalary';

const hasValue = (value, salary) => path(['amount', value], salary) !== 0;
const hasSalary = (salary) => hasValue('from', salary) || hasValue('to', salary);

const hasWorkValues = compose(any(Boolean), props(['workplace', 'schedule', 'worktype', 'bonuses', 'probation']));
const hasWorkConditions = (request) => hasWorkValues(request) || hasSalary(request.salary);

export const RequestWorkConditions = ({ request }) => hasWorkConditions(request) ? (
    <div>
        <DefinitionHeader translate="request.headers.workConditions" iconType="laptop" />
        <div className="panel-view">
            <DefinitionField translate="request.salary" show={hasSalary(request.salary)}>
                <LoadField loadName={currency} component={RequestSalary} salary={request.salary} />
            </DefinitionField>
            <DefinitionField translate="request.bonuses" text={ request.bonuses } />
            <DefinitionField translate="request.probation" text={ request.probation } />
            <DefinitionField translate="request.workplace" show={request.workplace}>
                <LoadField loadName={workplace} fieldId={ request.workplace } />
            </DefinitionField>
            <DefinitionField translate="request.schedule" show={request.schedule}>
                <LoadField loadName={schedule} fieldId={ request.schedule } />
            </DefinitionField>
            <DefinitionField translate="request.workType" show={request.worktype}>
                <LoadField loadName={worktype} fieldId={ request.worktype } />
            </DefinitionField>
        </div>
    </div>
) : null;
